import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { complianceRouteRef } from './routes';

export const compliancePlugin = createPlugin({
         id: 'compliance',
         routes: {
           root: complianceRouteRef,
         },
       });

export const CompliancePage = compliancePlugin.provide(
  createRoutableExtension({
    name: 'CompliancePage',
    component: () =>
      import('./components/Compliance').then(m => m.CompliancePage),
    mountPoint: complianceRouteRef,
  }),
);
